/**
 * ARCHIVO DE DESARROLLO generado por scripts/set-env.js a partir de .env.
 * Si no existe .env, usa estos valores por defecto para poder compilar.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'http://localhost:8080/api/v1',
  appName: 'Sentinel ERP',
  tokenRefreshThresholdMs: 60000,
};
